import { BaseTypeModel } from '../base/base-type.model';

export class EquipmentTypeModel extends BaseTypeModel {
    public static fields: Array<string> = BaseTypeModel.fields.concat([
        'attachable'
    ]);

    public attachable: boolean;
}
